
// import React, { useContext, useEffect, useState } from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Button,
//     FormControl,
//     ToggleButtonGroup,
//     ToggleButton,
//     Container,
//     useTheme,
// } from '@mui/material';
// import { AppThemeContext } from '../../context/AppThemeContext';

// const ColorPaletteDialog = ({ open, onClose, onSelectColors }) => {
//     const { setPrimaryColor, PrimaryColor } = useContext(AppThemeContext);
//     const [alignment, setAlignment] = useState(PrimaryColor || '#2C3E50'); // Fallback just in case

//     useEffect(() => {
//         setAlignment(PrimaryColor);
//     }, [PrimaryColor, open]);


//     const handleChange = (event, newAlignment) => {
//         if (newAlignment) {
//             localStorage.setItem('UserTheme', newAlignment);
//             setPrimaryColor(newAlignment);
//             setAlignment(newAlignment);
//         }
//     };

//     const handleDone = () => {
//         onClose();
//     };

//     // const colorGroup = {
//     //     Color1: "#25476A",
//     //     Color2: "#03A9F4",
//     //     Color3: "#574476",
//     //     Color4: "#0D6EFD",
//     //     Color5: '#356E35',
//     //     Color6: '#FFA500',
//     //     Color7: "#2C3E50",
//     //     Color8: "#F29F67",
//     //     Color9:'#f44336',
//     //     Color10:'#D2691E',
//     //     Color11:'#DC143C',
//     //     Color12:'#B8860B',
//     //     Color13:'#556B2F',
//     //     Color14:'#FF8C00',
//     //     Color15:'#2F4F4F',
//     //     Color16:"#000000",
//     //     Color17:"#0f4539"
//     // };

//     const colorGroup = {
//         Color1: "#25476A",
//         Color2: "#574476",
//         Color3: '#356E35',
//         Color4: "#2C3E50",
//         Color5: '#DC143C',
//         Color6: '#B8860B',
//         Color7: '#556B2F',
//         Color8: '#2F4F4F',
//         Color9: "#000000",
//         Color10: "#0f4539",

//         Color11: "#03A9F4",
//         Color12: "#0D6EFD",
//         Color13: '#FFA500',
//         Color14: "#F29F67",
//         Color15: '#f44336',
//         Color16: '#D2691E',
//         Color17: '#FF8C00',
//     };

//     return (
//         <Dialog open={open} component={Container} maxWidth='md' onClose={onClose}>
//             <DialogTitle>Choose Color Palette</DialogTitle>
//             <DialogContent sx={{}}>
//                 <FormControl fullWidth>
//                     <ToggleButtonGroup
//                         color="primary"
//                         value={alignment}
//                         exclusive
//                         onChange={handleChange}
//                         aria-label="Platform"
//                     >
//                         {Object.entries(colorGroup).map(([key, value]) => (
//                             <ToggleButton sx={{ bgcolor: `${value}` }} value={value} key={key}>
//                                 {key}
//                             </ToggleButton>
//                         ))}
//                     </ToggleButtonGroup>
//                 </FormControl>
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={handleDone} >
//                     Done
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// };

// export default ColorPaletteDialog;

import React, { useContext, useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    ToggleButtonGroup,
    ToggleButton,
    Container,
} from '@mui/material';
import { AppThemeContext } from '../../context/AppThemeContext';

const ColorPaletteDialog = ({ open, onClose }) => {
    const { setPrimaryColor, PrimaryColor } = useContext(AppThemeContext);

    const colorGroup = {
        

        Color1: "#25476A",
        Color2: "#574476",
        Color3: '#356E35',
        Color4: "#2C3E50",
        Color5: '#556B2F',
        Color6: '#2F4F4F',
        Color7: "#000000",
        Color8: "#0f4539",
        Color9: "#03A9F4",
        Color10: "#0D6EFD",
        Color11: '#FFA500',
        Color12: "#F29F67",
        Color13: '#f44336',
        Color14: '#D2691E',
        Color15: '#FF8C00',
    };

    const [alignment, setAlignment] = useState(PrimaryColor || '#2C3E50');
    const colorKeys = Object.keys(colorGroup);
    const rotatingKeys = colorKeys.slice(0, 8); // First 10 colors

    // Automatically rotate every day based on date
    useEffect(() => {
        const userSelected = localStorage.getItem('UserTheme_Manual');
        if (!userSelected) {
            const today = new Date();
            const dayIndex = today.getDate() % 8;
            const rotatingColor = colorGroup[rotatingKeys[dayIndex]];
            setAlignment(rotatingColor);
            setPrimaryColor(rotatingColor);
        }
    }, [open]);

    useEffect(() => {
        setAlignment(PrimaryColor);
    }, [PrimaryColor, open]);

    const handleChange = (event, newAlignment) => {
        if (newAlignment) {
            localStorage.setItem('UserTheme', newAlignment);
            localStorage.setItem('UserTheme_Manual', 'true');
            setPrimaryColor(newAlignment);
            setAlignment(newAlignment);
        }
    };

    const handleDone = () => {
        onClose();
    };

    return (
        <Dialog open={open} component={Container} maxWidth="md" onClose={onClose}>
            <DialogTitle>Choose Color Palette</DialogTitle>
            <DialogContent>
                <FormControl fullWidth>
                    <ToggleButtonGroup
                        color="primary"
                        value={alignment}
                        exclusive
                        onChange={handleChange}
                        aria-label="color theme"
                    >
                        {Object.entries(colorGroup).map(([key, value]) => (
                            <ToggleButton
                                key={key}
                                value={value}
                                sx={{
                                    bgcolor: value,
                                    color: "#fff",
                                    '&.Mui-selected': {
                                        border: '2px solid white',
                                        fontWeight: 'bold',
                                    }
                                }}
                            >
                                {key}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDone}>Done</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ColorPaletteDialog;
